import type { MenuDesignTokens, MenuTokenSections } from '@primeuix/themes/types/menu';

export const root: MenuTokenSections.Root = {
    background: 'none',
    borderColor: 'none',
    color: '{content.color}',
    borderRadius: '{content.borderRadius}',
    shadow: '{overlay.navigation.shadow}',
    transitionDuration: '{transitionDuration}'
};

export const list: MenuTokenSections.List = {
    padding: '{navigation.list.padding}',
    gap: '{navigation.list.gap}'
};

export const item: MenuTokenSections.Item = {
    focusBackground: '{navigation.item.focusBackground}',
    color: '{navigation.item.color}',
    focusColor: '{navigation.item.focusColor}',
    padding: '{navigation.item.padding}',
    borderRadius: '{navigation.item.borderRadius}',
    gap: '{navigation.item.gap}',
    icon: {
        color: '{navigation.item.icon.color}',
        focusColor: '{navigation.item.icon.focusColor}'
    }
};

export const submenuLabel: MenuTokenSections.SubmenuLabel = {
    padding: '{navigation.submenuLabel.padding}',
    fontWeight: '{navigation.submenuLabel.fontWeight}',
    background: '{navigation.submenuLabel.background}',
    color: '{navigation.submenuLabel.color}'
};

export const separator: MenuTokenSections.Separator = {
    borderColor: '{content.borderColor}'
};

export default {
    root,
    list,
    item,
    submenuLabel,
    separator
} satisfies MenuDesignTokens;
